export default __webpack_public_path__ + "static/media/QR-pyörä.4ed02e1b.png";